'use strict';

var MarketAnalysisThematicChartsDirective = function MarketAnalysisThematicChartsDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'MarketAnalysisThematicChartsController',
    template: require('../templates/market-analysis-thematic-charts.html'),
    link: function link(scope) {
      function oneDaySelectedHandler(event, isOneDaySelected) {
        scope.oneDaySelected = isOneDaySelected;
        scope.isOneMarketSelectedForServiceTab(event.name, isOneDaySelected);
        scope.changeVisibility();
      }
      function selectedMetricHandler() {
        scope.changeVisibility();
      }
      scope.$on('market-analysis:oneMarketSelected', scope.oneMarketSelectedHandler);
      scope.$on('market-analysis:oneDaySelected', oneDaySelectedHandler);
      scope.$on('service-analysis:oneDaySelected', oneDaySelectedHandler);
      scope.$on('market-analysis:resetDaysSelection', oneDaySelectedHandler);
      scope.$watch('metrics.selectedMetric', selectedMetricHandler);
    }
  };
};
MarketAnalysisThematicChartsDirective.$inject = [];
module.exports = MarketAnalysisThematicChartsDirective;